
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class FishTable extends Vue {
    //捕鱼大战、3D捕鱼、大闹天宫、金蟾捕鱼
    table = {
        data: [],
        //捕鱼
        column: [
            {
                key: 'Base',
                title: '金币倍数',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).Base) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).Base)
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'FireTimes',
                title: '总共开枪次数',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).FireTimes
                    return h('span', strzo)
                }
            },
            {
                key: 'FirePoint',
                title: '总消耗金币',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).FirePoint) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).FirePoint, 1)
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'Level',
                title: '击中鱼的子弹等级',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).Level) {
                        strzo = JSON.parse(params.row.opt_detail).Level
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'RewardPoint',
                title: '击杀获得金币',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).RewardPoint) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).RewardPoint, 1)
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'AttachFishes',
                title: '击杀鱼的条数',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).AttachFishes) {
                        strzo = 1 + JSON.parse(params.row.opt_detail).AttachFishes.length
                    } else if (!JSON.parse(params.row.opt_detail).AttachFishes && typeof JSON.parse(params.row.opt_detail).AttachFishes != 'undefined' && JSON.parse(params.row.opt_detail).AttachFishes != 0) {
                        strzo = 1
                    } else if (typeof JSON.parse(params.row.opt_detail).AttachFishes == 'undefined') {
                        strzo = 0
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'AttachFishes',
                title: '击杀鱼的种类',
                align: 'center',
                width: 150,
                render: (h, params) => {
                    let strzo: any
                    let obj = JSON.parse(params.row.opt_detail)
                    if (typeof obj.CatchFish == 'undefined') {
                        strzo = '/'
                    } else {
                        strzo = this.fishType(params.row.game_id, obj.CatchFish.Idx) + '（' + obj.CatchFish.Reward + '倍' + '）'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'PrizeRate',
                title: '返奖率',
                align: 'center',
                render: (h, params) => {
                    let str = '/'
                    if (JSON.parse(params.row.opt_detail).PrizeRate) {
                        str = JSON.parse(params.row.opt_detail).PrizeRate + '%'
                    }
                    return h('span', str)
                }
            }
        ]
    }
    //捕鱼的种类
    fishType(type, id) {
        if (type == 3001) {
            // let arr = ['扯旗鱼','河豚鱼','小丑鱼','小黄鱼','草鱼','小金鱼','鲂鱼','金枪鱼','剑鱼','灯笼鱼','海龟','蝙蝠鱼','金鲨鱼','章鱼','海豚','鲨鱼','鲸鱼','锤头鲨','金色虎鲨','金钱豹','犀牛','大猩猩','大象','金色虎鲨','美人鱼','海神','火神','闪电弹','爆炎弹','冰冻弹','海神','火神','雷神','一网打尽(扯旗鱼)','一网打尽(河豚鱼)','一网打尽(小丑鱼)','一网打尽(小黄鱼)','一网打尽(电鳗鱼)']
            let arr = ['扯旗鱼', '河豚鱼', '小丑鱼', '小黄鱼', '草鱼', '小金鱼', '鲂鱼', '金枪鱼', '剑鱼', '灯笼鱼', '海龟', '蝙蝠鱼', '金鲨鱼', '章鱼', '海豚', '鲨鱼', '鲸鱼', '锤头鲨', '金色虎鲨', '美人鱼', '金蟾', '海神', '火神', '闪电弹', '爆炎弹', '一网打尽(扯旗鱼)', '一网打尽(河豚鱼)', '一网打尽(小丑鱼)', '一网打尽(小黄鱼)', '一网打尽(电鳗鱼)']
            return arr[id - 1]
        } else if (type == 3002) {
            let arr = ['扯旗鱼', '河豚鱼', '天使鱼', '小丑鱼', '小黄鱼', '小金鱼', '电鳗鱼', '鲂鱼', '金枪鱼', '海龟', '鲶鱼', '灯笼鱼', '鳐鱼', '箭鱼', '狮子鱼', '海豚', '红色锦鲤', '章鱼', '鲨鱼', '锤头鲨', '金色鲨鱼', '鲸鱼', '美人鱼', '银龙', '金蟾', '玉兔精', '李逵', '金龙', '猪八戒-闪电', '猪八戒-冰冻', '猪八戒-火焰']
            return arr[id - 1]
        } else if (type == 3003) {
            let arr = ['蜗牛鱼', '绿草鱼', '黄草鱼', '大眼鱼', '黄边鱼', '小丑鱼', '小刺鱼', '蓝鱼', '灯笼鱼', '将军虾', '海龟', '飞鱼', '剑鱼', '蝙蝠鱼', '海豚', '银鲨', '金鲨', '蓝鲸', '霸王银鲨', '霸王金鲨', '金龙王', '孙悟空', '金箍棒', '深水炸弹', '一网打尽(大眼鱼)', '一网打尽(黄边鱼)', '一网打尽(小丑鱼)', '一网打尽(灯笼鱼)', '一网打尽(将军虾)']
            return arr[id - 1]
        } else if (type == 3004) {
            let arr = ['蜗牛鱼', '绿草鱼', '黄草鱼', '大眼鱼', '黄边鱼', '小丑鱼', '小刺鱼', '蓝鱼', '灯笼鱼', '海龟', '花斑鱼', '蝴蝶鱼', '孔雀鱼', '剑鱼', '蝙蝠鱼', '神秘鱼', '银鲨', '金鲨', '双头企鹅', '霸王金鲨', '银龙王', '金龙王', '金蟾', '深水炸弹', '一网打尽(蜗牛鱼)', '一网打尽(绿草鱼)', '一网打尽(黄边鱼)', '一网打尽(小丑鱼)', '一网打尽(灯笼鱼)']
            return arr[id - 1]
        } else if (type == 3005) {
            let arr = ['小黄鱼', '小豚鱼', '小飞鱼', '小红鱼', '小紫鱼', '小伞鱼', '粉红鱼', '爱情鱼', '海墨鱼', '荧光水母', '绿甲龟', '金枪鱼', '灯笼鱼', '海玳瑁', '蝙蝠鱼', '大海豚', '锤头鲨', '章鱼', '黄金水母', '黄金玳瑁', '黄金甲鱼', '黄金海豚', '黄金巨鲸', '黄金章鱼', '海怪鱼', '黄金蟾蜍', '烈焰巨龙', '冰霜巨龙', '勾魂水手', '迷魂水手', '幽灵船长', '海神波塞冬', '银龙王', '炸弹', '小三元', '大三元', '大四喜', '五福临门', '食人鱼王', '一网打尽(小紫鱼)', '一网打尽(小伞鱼)', '一网打尽(海墨鱼)', '一网打尽(绿甲龟)', '一网打尽(灯笼鱼)']
            return arr[id - 1]
        } else if (type == 3006) {
            let arr = ['小绿鱼', '小丑鱼', '神仙鱼', '河豚鱼', '翻车鱼', '小绿龟', '狮子鱼', '灯笼鱼', '蓝色蝙蝠鱼', '榔头鱼', '海精灵', '美人鱼', '蝠王鱼', '小黄鱼', '鲨鲨鲨', '四皇', '黄金蝙蝠鱼', '宝箱小蟹', '黄金榔头鲨', '倍增河豚', '黄金水母', '黄金海龟', '烈焰章鱼', '黄金龙虾', '觉醒金蟾', '座头鲸', '深渊海龙', '闪电连锁', '炸弹蟹']
            return arr[id - 1]
        }
    }

    @Prop()
    listdata
}
